module.exports = __webpack_public_path__ + "media/bootstrap-icons/snow-ff261004.svg";